import "../../node_modules/parsleyjs";
import "../vendor/5fr"; // Message en français de parsley


function parseRequirement(requirement) {
    if (isNaN(requirement)) {
        return parseFloat($(requirement).val())
    }
    else {
        return requirement
    }
}

// function calculateAge(date) {
//     var ageDifMs = Date.now() - date.getTime()
//     var ageDate = new Date(ageDifMs)
//     return Math.abs(ageDate.getUTCFullYear() - 1970)
// }

// N° de telephone Validateur

Parsley.addValidator('telephone', {
    requirementType: 'string',
    validateString: function (phone) {
        return /^(((\+)33|0)[1-9]((\.|\-|\||\/|\s?)\d{2}){4})?$/g.test(phone)
    },
    messages: {
        en: 'It\'s not a valid french phone number.',
        fr: 'Ce n\'est pas un numéro de téléphone valide.'
    }
})

// N° de portable Validateur
Parsley.addValidator('mobile_phone', {
    requirementType: 'string',
    validateString: function (phone) {
        return /^((\+)33|0)[6-7]((\.|\-|\||\/?)\d{2}){4}$/g.test(phone)
    },
    messages: {
        en: 'It\'s not a valid french phone number.',
        fr: 'Ce n\'est pas un numéro de téléphone portable valide.'
    }
})


// Date de naissance validateur
// Parsley.addValidator('birthday',
//     function (value) {
//         var date = new Date(value)
//         //consider invalid dates as ok
//         if(date instanceof Date && isNaN(date.getTime())){
//             return true
//         }
//         var diff = calculateAge(date)

//         if (diff >= 18) {
//             return true
//         } else {
//             return false
//         }
//     }, 34
// )

// Adresse validateur
Parsley.addValidator('address', {
    requirementType: "string",
    validateString: function(value, form) {
        var $location_form        = $("#"+form)
        var $location_lat         = $('[name="location_lat"]', $location_form)
        var $location_lng         = $('[name="location_lng"]', $location_form)

        if ($location_lat.val() == "" || $location_lng.val() == "") {
            return false
        } else {
            return true
        }
    },
    messages: {
        fr: 'Ce n\'est pas une adresse valide.'
    }
})

// Greater than or equal to validator
Parsley.addValidator('gte', {
    validateString: function (value, requirement) {
        var compareValue = parseRequirement(requirement);        
        return  isNaN(compareValue) ? true: (parseFloat(value) >= compareValue);
    }
})

// Les thanor equal to validator
Parsley.addValidator('lte', {
    validateString: function (value, requirement) {
        var compareValue = parseRequirement(requirement);        
        return  isNaN(compareValue) ? true: (parseFloat(value) <= compareValue);        
    }
    
})

// Ifcheck Validator
Parsley.addValidator('requiredifchecked', {
    requirementType: "string",
    validateString: function (value, requirement) {        
        var checked = $(requirement).prop('checked');
        return (value!='' && checked) || !checked;
    },
    messages: {
        fr: 'Ce champ est obligatoire.'
    }
})

function isValidDate(s) {
    var bits = s.split('-');
    var y = bits[0],
        m = bits[1],
        d = bits[2];

    // Assume not leap year by default (note zero index for Jan)
    var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // If evenly divisible by 4 and not evenly divisible by 100,
    // or is evenly divisible by 400, then a leap year
    if ((!(y % 4) && y % 100) || !(y % 400)) {
        daysInMonth[1] = 29;
    }

    return !(/\D/.test(String(d))) && d > 0 && d <= daysInMonth[--m]
}

// if($('#young_error').length > 0){
//     birthday_msg = $('#young_error').html();
// }else{
//     birthday_msg = 'Vous devez être majeur(e).';
// }
//var birthday_msg = 'Vous devez être majeur(e).';

// Date validateur
Parsley.addValidator('date',
    function(value, requirements) {
        var valueDate = $('.js-input-date').val(),
            arrayDate = valueDate.split('-'),
            dateTime  = new Date(valueDate);

        if ( Object.prototype.toString.call(dateTime) === "[object Date]" ) {
            // it is a date
            if ( isValidDate(valueDate) ) {
                // date is valid
                return true;
            } else {
                // date is not valid
                return false;
            }
        } else {
            // not a date
            return false;
        }
    }, 34
)

Parsley.addMessages('fr', {
    gte: "Cette valeur doit être plus grande ou égale.",    
    date: "La date indiquée n'est pas valide."
})



/**
 *  Initialise un formulaire parsley
 * 
 */
function setFormsCheck() {
    var forms = $('.js-form-check')

    $.each(forms, function (f, el) {
        var $form = $(el)
        var $slider = $form.closest('.js-owl-carousel')

        $form.parsley({
            inputs: Parsley.options.inputs,
            excluded: 'input[type=button], input[type=submit], input[type=reset], [disabled]',
            errorClass: 'error',
            successClass: 'success',
            trigger: 'change blur',
            errorsContainer: function (field) {
                var $field = $(field.$element)
                if ($field.hasClass('form-group')) {
                    return $field
                }
                return $field.closest('.form-group')
            },
            classHandler: function (field) {
                var $field = $(field.$element)
                return $field
            },
            errorsWrapper: '<ul class="error-text parsley-errors-list"></ul>'
        })

        window.Parsley.on('form:validated', function (e) {
            autoHeightSlider($slider)
        })

        window.Parsley.on('field:validated', function (e) {
            autoHeightSlider($slider)
        })

        window.Parsley.on('form:error', function (formInstance) {
            var $form = $(formInstance.$element);
            var firstErrorElement = $form.find('.error:first').closest(".form-group");       
            $(firstErrorElement).scrollToElementIfNonVisible();
            
            
        })

        $form.find('[type="reset"]').on('click', function () {
            $form.parsley().reset()
        })
    })
}



$('[data-color-button]').on('click', function(){
    var $label = $(this)
    var color = $label.data('color-button')
    var $button = $label.closest('form').find('[type="submit"]')
    $button.removeClass('pink green').addClass(color)
})



/*----------  Domready  ----------*/
$(document).ready(function () {
    setFormsCheck()    

    // $('#birthday').on('keyup', function(e){
    //     if (this.value.length == 2) {
    //         $('#birthmonth').focus();
    //     }
    // });

    // $('#birthmonth').on('keyup', function(e){
    //     if (this.value.length == 2) {
    //         $('#birthyear').focus();
    //     }
    // });

    // $('#birthyear').on('keyup', function(e){
    //     if (this.value.length == 4) {
    //         $(this).blur()
    //         // $('[data-parsley-date]').parsley().validate()
    //     }
    // });



/**Obsolète utiliser un CF kg-commentaires */
    $(document.body).on('keyup change', 'textarea[data-lengthcounter]', function(ev) {
        var $this = $(this),
            $block = $this.siblings('.help-block'),
            message = $block.data('message').split('|'),
            currentLength = $this.val().replace(/\r\n/g, "\n").length,
            maxLength = $this.data('lengthcounter'),
            lengthRemaining = maxLength - currentLength;

        if (lengthRemaining <= 0) {
            lengthRemaining = 0;
            $this.val($this.val().substr(0, maxLength));
        }

        if (lengthRemaining <= 1) {
            $block.html(message[0].replace('%s', lengthRemaining));
        } else {
            $block.html(message[1].replace('%s', lengthRemaining));
        }
    });
    
    /**
     * Gestion de la touche "enter" equivalent à un  click sur continuer
     */
    $("form").on('keypress',function(e) {
        if (e.which == 13) {
            $form = $('.js-owl-carousel .owl-item.active form');
            if($form.length > 0) {
                if($form[0].checkValidity()) {
                    $btnSubmit = $('.js-owl-carousel .owl-item.active form .js-trigger-next');
                    if($btnSubmit.length > 0) {
                      $btnSubmit[0].click();
                    }
                }
                else {
                    if( $('.js-owl-carousel .owl-item.active form .error-text').length <= 0 ) {
                        $('.js-owl-carousel .owl-item.active form .tap-blocs').append(
                            '<ul class="error-text parsley-errors-list filled" id="parsley-id-multiple-age_child" aria-hidden="false"><li class="parsley-required">Ce champ est requis.</li></ul>'    
                        ) 
                    }
                }
            }
            console.log($form[0]);
            console.log($form[0].checkValidity());
            return false;
        }
    });
});



/****************   OCS **************************** */

(function(w) {
    w.Kinougarde = Object.assign({},w.Kinougarde, { Form : {}});

    /**
     * Retourne le Html d'un message d'erreur Ajax
     */
    w.Kinougarde.Form.getMessageErrorAjax = function(reponse)  {
        var message = "Désolé, une erreur a été détectée, veuillez réessayer plus tard";
        try {
            if (typeof(reponse.responseJSON)!==undefined && reponse.responseJSON && reponse.responseJSON.data && reponse.responseJSON.data.error_msg) {
                message = reponse.responseJSON.data.error_msg;                            
            }
            else if (typeof(reponse.data)!=='undefined' && typeof(reponse.data.error_msg)!=='undefined') {
                message = reponse.data.error_msg;
            }
        }
        catch (e) {
        }
        finally {
            // Supprime les erreurs précédentes
            $("div.ajax-error").remove();
            return '<div class="ajax-error"><div class="notice-error text-center">' + message + '</div></div>';                  
        }
    }
})(window);

